import React, { Component, useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom'
import IconUser from "../icon/IconUser"
import IconKontrol from "../icon/IconKontrol"
import IconLogout from "../icon/IconLogout"

const SidebarData = [
    {
        title: "Dashboard",
        icon: <IconKontrol color="#66B0F0" />,
        iconactive: <IconKontrol color="#C4C4C4" />,
        link: "/kontrollpanel",
        links: "/"
    },
    {
        title: "Profile",
        icon: <IconUser color="#66B0F0" />,
        iconactive: <IconUser color="#C4C4C4" />,
        link: "/profil",
        links: "/profil"
    }
]

function Sidebar(props) {

    var language = props.language;

    return (
        <div className="sidebar">
            <div className="sidebar-head">
                <img src="assets/logo/edeffective.png" alt=""></img>
            </div>
            <div className="sidebar-menu">
                <div className="sidebar-body">
                    <ul>
                        {
                            (props.level == 1) ?
                                SidebarData.map((val, key) => {
                                    return (

                                        <li key={key}>
                                            {window.location.pathname === val.link || window.location.pathname === val.links ? val.icon : val.iconactive}
                                            <Link to={val.link} className={window.location.pathname === val.link || window.location.pathname === val.links ? "" : "text-c4"}>
                                                {val.title === "Dashboard" ? language.dashboard_menu : language.profile_menu}
                                            </Link>
                                        </li>
                                    );
                                })
                                :
                                SidebarData.map((val, key) => {
                                    return (
                                        (val.title == 'Profile') ?
                                            <li key={key}>
                                                {window.location.pathname === val.link || window.location.pathname === val.links ? val.icon : val.iconactive}
                                                <Link to={val.link} className={window.location.pathname === val.link || window.location.pathname === val.links ? "" : "text-c4"}>
                                                    {val.title === "Dashboard" ? language.dashboard_menu : language.profile_menu}
                                                </Link>
                                            </li>
                                            : ''
                                    );
                                })
                        }
                    </ul>
                </div>
                <div className="sidebar-foot">
                    <ul>
                        <li>
                            <IconLogout color="#66B0F0" />

                            <Link to="/logout">{language.logout_menu}</Link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;